import React, { useEffect, useState } from 'react';
import supabase from "../../../supabaseClient";
import './GroupMainFeed.css';

const GroupMainFeed = ({ groups, onSelectGroup, user, onGroupCreated }) => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchActivities = async () => {
      if (!user || !groups.length) {
        setActivities([]);
        return;
      }
      setLoading(true);
      try {
        // Fetch posts from all groups the user belongs to
        const groupIds = groups.map(g => g.id);
        const { data: posts, error: postsError } = await supabase
          .from('posts')
          .select('id, content, created_at, group_id, user_id, media_url, media_type')
          .in('group_id', groupIds)
          .order('created_at', { ascending: false });
        if (postsError) throw postsError;
        // You can add more activity types here (e.g., events, messages)
        // For now, only posts are shown
        // Map posts to activity items
        const postActivities = (posts || []).map(post => ({
          type: 'post',
          id: post.id,
          group_id: post.group_id,
          user_id: post.user_id,
          content: post.content,
          created_at: post.created_at,
          media_url: post.media_url,
          media_type: post.media_type
        }));
        // Combine and sort all activities by created_at desc
        const allActivities = [...postActivities].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setActivities(allActivities);
      } catch (err) {
        setActivities([]);
      } finally {
        setLoading(false);
      }
    };
    fetchActivities();
  }, [user, groups]);

  const getGroupById = (id) => groups.find(g => g.id === id);



  return (
    <div className="group-main-feed">
      <div className="group-feed-header">
        <h2>Group Activity Feed</h2>
      </div>
      {groups.length === 0 ? (
        <div className="no-groups-message">
          <p>You haven't joined any groups yet.</p>
          <p>Browse or create a group to get started!</p>
        </div>
      ) : loading ? (
        <div className="loading-message">Loading recent activity...</div>
      ) : activities.length === 0 ? (
        <div className="no-activity-message">No recent activity in your groups yet.</div>
      ) : (
        <ul className="group-feed-list">
          {activities.map(activity => {
            const group = getGroupById(activity.group_id);
            if (!group) return null;
            return (
              <li key={activity.type + '-' + activity.id} className="group-feed-item" onClick={() => onSelectGroup(group.id, activity.id)}>
                <img src={group.group_banner_url || '/default-group.png'} alt={group.name} className="group-feed-avatar" />
                <div className="group-feed-info">
                  <span className="group-feed-name">{group.name}</span>
                  <span className="group-feed-activity-type">{activity.type === 'post' ? 'New Post' : activity.type}</span>
                  <span className="group-feed-timestamp">{new Date(activity.created_at).toLocaleString()}</span>
                  <div className="group-feed-description-container">
                    {activity.content}
                  </div>
                  {activity.media_url && activity.media_type && (
                    <div className="group-feed-media">
                      {activity.media_type.startsWith('image') ? (
                        <img src={activity.media_url} alt="media" className="group-feed-media-img" />
                      ) : activity.media_type.startsWith('video') ? (
                        <video src={activity.media_url} controls className="group-feed-media-video" />
                      ) : null}
                    </div>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      )}

    </div>
  );
};

export default GroupMainFeed;